enum TypeDossierProduction {
    PlasticMaterialStock = "PlasticMaterialStock" ,
    NonStockInCatalog = "NonStockInCatalog" ,
    NonStockNotInCatalog = "NonStockNotInCatalog" ,
    Veneer = "Veneer" ,
    Solid = "Solid" ,
    LacquerIntern = "LacquerIntern" ,
    LacquerExtern = "LacquerExtern" ,
    ShowroomKitchen = "ShowroomKitchen" ,
}

export default TypeDossierProduction;